import React, { Component } from "react";

const ProfileIcon = ({ width, height, fill, ...rest }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <mask
          id="mask0_1596_16148"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="14"
          height="14"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.09925 1.15962C8.29117 1.15962 9.26099 2.06555 9.26099 3.17896C9.26099 4.29236 8.29117 5.19829 7.09925 5.19829C5.90732 5.19829 4.9375 4.29236 4.9375 3.17896C4.9375 2.06555 5.90732 1.15962 7.09925 1.15962M7.10065 6.2368C8.90564 6.2368 10.3741 4.86503 10.3741 3.17895C10.3741 1.49286 8.90564 0.121094 7.10065 0.121094C5.29565 0.121094 3.82715 1.49286 3.82715 3.17895C3.82715 4.86503 5.29565 6.2368 7.10065 6.2368M6.83938 12.8467C5.14522 12.8467 3.46594 12.7617 1.94922 12.5999C2.03998 10.799 2.93313 9.17064 4.34334 8.23001C5.09624 8.61351 6.01195 8.82199 6.96338 8.82199C7.9148 8.82199 8.83051 8.61351 9.58342 8.23001C10.9866 9.16593 11.8777 10.7827 11.9762 12.5727C10.3963 12.7523 8.63212 12.8467 6.83938 12.8467M9.89132 7.17756L9.58579 7.00174L9.28683 7.18699C8.66227 7.57417 7.8367 7.78736 6.96203 7.78736C6.08736 7.78736 5.26179 7.57417 4.63723 7.18699L4.33827 7.00174L4.03274 7.17756C2.05364 8.31713 0.824219 10.5116 0.824219 12.9045C0.824219 12.9589 0.824219 13.0145 0.825583 13.0689L0.836246 13.5132L1.3114 13.5706C2.99986 13.7743 4.91088 13.8819 6.83803 13.8819C8.86847 13.8819 10.8668 13.7633 12.617 13.539L13.0852 13.479L13.0984 13.0409C13.0998 12.9958 13.0998 12.9496 13.0998 12.9045C13.0998 10.5116 11.8704 8.31713 9.89132 7.17756"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1596_16148)">
          <path
            d="M-50.3379 -35.3945H63.5268V49.3989H-50.3379V-35.3945Z"
            fill="#fff"
          />
        </g>
      </svg>
    </>
  );
};

ProfileIcon.defaultProps = {
  width: "14",
  height: "14",
  fill: "#E91E63",
};

export default ProfileIcon;
